import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

interface AuthLayoutProps {
  component: any;
  layout: any;
  path?: any;
}

const Authmiddleware = ({
  component,
  layout,
  path,
  ...rest
}: AuthLayoutProps) => {
  const Layout = layout;
  const Component = component;

  return (
    <Route
      {...rest}
      render={(props) => {
        if (path !== "/login" && !localStorage.getItem("authToken")) {
          return <Redirect to={{ pathname: "/login" }} />;
        }

        return (
          <Layout>
            <Component {...props} />
          </Layout>
        );
      }}
    />
  );
};

export default Authmiddleware;
